function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import _ from "lodash";
import SettingsButton from "./SettingsButton";
import SettingsDropdown from "./SettingsDropdown";
import SkinOptions from "./SettingsList";
const useStyles = makeStyles(theme => ({
  skin: {
    position: "absolute",
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    fontSize: 'inherit',
    width: '1.15em',
    height: '1.15em',
    borderRadius: '1em',
    backgroundColor: props => {
      return props.backgroundColor;
    },
    color: props => {
      return props.color;
    },
    margin: "-0.075em"
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: '0.75em',
    fontWeight: "bold",
    lineHeight: '1',
    textAlign: "center"
  }
}));

const SkinIcon = ({
  style
}) => {
  const classes = useStyles(style);
  return React.createElement(Paper, {
    className: classes.skin,
    elevation: 1
  }, React.createElement("b", {
    className: classes.label
  }, "A"));
};

const getOptions = ({
  options = [],
  styles = {}
}) => {
  let _options = [],
      _byValue = {};
  options.map((item, index) => {
    if (typeof item === "string") {
      item = {
        label: item,
        value: item
      };
    }

    const style = styles && styles[item.value];
    item = _extends({}, item, {
      icon: SkinIcon({
        style
      }),
      style: style
    });

    _options.push(item);

    _byValue[item.value] = item;
  });
  _options = _.orderBy(_options, 'order', 'desc');
  return {
    byValue: _byValue,
    options: _options
  };
};

const SettingsButtonRef = React.forwardRef((props, ref) => {
  return React.createElement(SettingsButton, _extends({}, props, {
    forwardedRef: ref
  }));
});

const SettingsSkin = (_ref) => {
  let _ref$type = _ref.type,
      type = _ref$type === void 0 ? "skin" : _ref$type,
      name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["type", "name", "label", "value", "onChange"]);

  const _React$useState = React.useState(false),
        expanded = _React$useState[0],
        setExpanded = _React$useState[1];

  const anchorRef = React.useRef(null);

  const _getOptions = getOptions(props),
        options = _getOptions.options,
        byValue = _getOptions.byValue;

  const current = byValue[value] || options[0];

  const onToggle = event => {
    setExpanded(prevExpanded => !prevExpanded);
  };

  const onSelect = item => {
    if (onChange) {
      onChange(name, item.value);
    }

    setExpanded(false);
  };

  const onCollapse = () => {
    setExpanded(false);
  };

  return React.createElement(React.Fragment, null, React.createElement(SettingsButtonRef, _extends({}, current, {
    type: type,
    onToggle: onToggle,
    expanded: expanded,
    ref: anchorRef
  })), React.createElement(SettingsDropdown, {
    expanded: expanded,
    anchorEl: anchorRef.current,
    onCollapse: onCollapse
  }, React.createElement(SkinOptions, {
    value: current && current.value,
    options: options,
    onSelect: onSelect
  })));
};

export default SettingsSkin;